// extracted by mini-css-extract-plugin
module.exports = {"naviBarBox":"index-naviBarBox-2bDxh","cookie":"index-cookie-Zdy0o"};